export { Timeline } from './Timeline';

export type { ITimelineProps } from './Timeline';
